import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaGraduationCap,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const TrainingAndELearningVideoProductionInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Training and E-Learning Video Production in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Empower Through Education</Subheading>}
        heading={
          <Heading>
            Training & E-Learning{" "}
            <span tw="text-primary-500">Video Production</span> in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in training and e-learning video
            production in **Bur Dubai**, creating engaging, interactive videos
            that enhance learning for businesses, schools, and professionals.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Educational setup
          "https://images.unsplash.com/photo-1604882737224-11d9142bd758?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Learning environment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Learning Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Effective Training Videos in Bur Dubai"
        description="We craft videos that educate and inspire."
        cards={[
          {
            icon: <FaGraduationCap color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Interactive videos to boost learner retention.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Professional Quality",
            description: "Clear visuals and audio for seamless learning.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Turnaround",
            description: "Fast delivery for your training needs.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Videos for LMS, apps, or social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Educators",
            description: "Bur Dubai’s choice for e-learning videos.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored for corporate or academic training.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our E-Learning Video Process"
        description={
          <Description>
            We create impactful training videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your learning objectives.</li>
              <li>Scripting: Develop clear, educational content.</li>
              <li>Filming: Capture visuals or animations for engagement.</li>
              <li>Editing: Add interactivity, quizzes, or subtitles.</li>
              <li>Delivery: Provide videos ready for your platform.</li>
              <li>Support: Offer revisions to perfect your vision.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Learning environment
          "https://images.unsplash.com/photo-1610484826967-09c5720778c7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Educational setup
          "https://images.unsplash.com/photo-1551845728-6820a30c64e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="E-Learning Video Wins in Bur Dubai"
        description="Our videos have transformed learning."
        cards={[
          {
            icon: <FaGraduationCap color="#ff5464" size={40} />,
            title: "Improved Retention",
            description: "Videos that enhanced learner outcomes.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "94% approval from Bur Dubai educators.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Wider Access",
            description: "Content reached diverse audiences online.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Educate?</Subheading>}
        heading="Training & E-Learning Video Production in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert training and e-learning video
            production in Bur Dubai. Get engaging, educational videos to empower
            your audience—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video production
          "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Learning environment
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Educational setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
